import DialogContent from '@material-ui/core/DialogContent';
import React, { useEffect } from 'react';
import {
	FileField,
	FileInput,
	TextInput,
	required,
} from 'react-admin';
import { useFormState } from 'react-final-form';

import { PassProps } from 'components/_helpers/PassProps';
import { GridForm, GridInput } from 'components/GridForm';
import { DocumentTemplateTypeSelect } from 'components/inputs/DocumentTemplateTypeSelect';


export const AddDocumentTemplateBody = ({form, handleValuesOnChange, enumObj,  ...rest}) => {
	const { values } = useFormState();

	useEffect(() => {
		handleValuesOnChange && handleValuesOnChange(values);
	}, [values]);

	return (
		<PassProps component={DialogContent} childPropKeys={["resource", "record"]} resource="document-templates" {...rest}>
			<GridForm>
				<GridInput xs={6} component={TextInput} source="name" label="resources.customer-companies-mapper.fields.name" validate={required()}/>
				<GridInput xs={6} component={DocumentTemplateTypeSelect} enumObj={enumObj} source="type" label="resources.customer-companies-mapper.fields.type" validate={required()} />
				<GridInput xs={6} source="file"  validate={required()}>
					<FileInput>
						<FileField source="" title="title" />
					</FileInput>
				</GridInput>
			</GridForm>
		</PassProps>
	);
};


export const EditDocumentTemplateBodyInfo = ({form, enumObj, ...rest}) => {
	return (
		<PassProps component={DialogContent} childPropKeys={["resource", "record"]} resource="document-templates" {...rest}>
			<GridForm>
				<GridInput component={TextInput} source="name" label="resources.customer-companies-mapper.fields.name" validate={required()}/>
				<GridInput component={DocumentTemplateTypeSelect} enumObj={enumObj} source="type" label="resources.customer-companies-mapper.fields.type" disabled validate={required()} />
			</GridForm>
		</PassProps>
	);
};


export const EditDocumentTemplateBodyFile = ({form, ...rest}) => {
	return (
		<PassProps component={DialogContent} childPropKeys={["resource", "record"]} resource="document-templates" {...rest}>
			<GridForm>
				<GridInput source="file"  validate={required()}>
					<FileInput>
						<FileField source="" title="title" />
					</FileInput>
				</GridInput>
			</GridForm>
		</PassProps>
	);
};
